import type { IconProps } from '__components/Kizen/Icon';
import type { NavItemContentProps } from './types';

import css from '@emotion/css';
import styled from '@emotion/styled';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { breakpoints } from 'app/spacing';
import { Label } from '__app/typography';
import Icon from '__components/Kizen/Icon';

interface StyledIconProps
  extends Pick<NavItemContentProps, 'badge' | 'icon' | 'noCustomIcon'>,
    Pick<IconProps, 'color'> {}

const StyledIcon = styled(Icon)<StyledIconProps>`
  display: none;
  @media (min-width: ${breakpoints.md + 1}px) {
    display: flex;
  }
  position: relative;

  ${({ badge }) =>
    badge
      ? css`
          &::after {
            content: '';
            position: absolute;
            top: -4px;
            right: -10px;
            width: 16px;
            height: 16px;
            background-color: var(--color-button-warning-default);
            border-radius: 50%;
            border: 2px solid var(--color-background-white);
          }
        `
      : ''}
`;

const NavItemContent = memo(
  ({ icon, label, noCustomIcon, badge }: NavItemContentProps) => {
    const { t } = useTranslation();

    return (
      <>
        <StyledIcon
          icon={icon}
          color="var(--color-background-darker)"
          noCustom={noCustomIcon}
          badge={badge}
        />
        <Label as="span" textTransform="none">
          {typeof label === 'function' ? label(t) : label}
        </Label>
      </>
    );
  }
);

export default NavItemContent;

NavItemContent.displayName = 'NavItemContent';
